<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />

      </b-col>
    </b-row>


    <b-row class="match-height" v-if="statistics">
      <b-col cols="12" class="my-1">
        <h2>
          آمار ترانسفر
        </h2>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="ApertureIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            کل ترانسفر :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.total_cars}} </strong>
          </div>
        </div>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="ApertureIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            ترانسفر فعال :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.total_active_cars}} </strong>
          </div>
        </div>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="ApertureIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            کل وسیله نقلیه :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.total_unit_cars}} </strong>
          </div>
        </div>
      </b-col>
      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="ApertureIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            کل وسیله های فعال :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.total_unit_cars_active}} </strong>
          </div>
        </div>
      </b-col>

      <b-col
          xl="2"
          md="4"
          sm="6"
      >
        <div class="card p-2 d-flex flex-column justify-content-center align-items-center">
          <div>
            <feather-icon
                icon="ApertureIcon"
                size="28"
            />
          </div>
          <div class="my-1">
            ترانسفره هایی با قابلیت رزرو :
          </div>
          <div class="font-weight-bold">
            <strong>{{statistics.total_unit_cars_active}} </strong>
          </div>
        </div>
      </b-col>

    </b-row>



  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";

export default {
  components: {
    StatisticCardVertical,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      statistics: [],
      residences: null,
      cars: null,
      tours: null,
      experiences: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      countryInput: {
        name: "",
        slug:"",
        status:"active"

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.getStatistics();
  },

  methods: {

    async getStatistics() {
      this.cancelToken = this.$http.CancelToken.source();
      const requestData = {
        method: "get",
        url: "/admin/statistics/cars",

      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.statistics = data.data;
            console.log(this.statistics)
          })
          .catch((err) => {
            console.log(err);
          });
    },




  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
